import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import getWeekStartDay from '../selectors/getWeekStartDay';
import getTimeIncrement from '../selectors/getTimeIncrement';
import getWorkDays from '../selectors/getWorkDays';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';
import getFirstWeekOfYear from '../selectors/getFirstWeekOfYear';
import getWorkingHoursStartTime from '../selectors/getWorkingHoursStartTime';
import getWorkingHoursEndTime from '../selectors/getWorkingHoursEndTime';
import getWorkingHoursTimeZoneId from '../selectors/getWorkingHoursTimeZoneId';

/**
 * Returns if the appearance option state is dirty
 */
export default function IsAppearanceOptionDirtyState() {
    let calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();
    if (!calendarConfiguration) {
        return false;
    }

    const WorkingHoursTimeZoneId =
        calendarConfiguration.WorkingHoursTimeZone &&
        calendarConfiguration.WorkingHoursTimeZone.TimeZoneId;

    return (
        getWeekStartDay() !== calendarConfiguration.WeekStartDay ||
        getTimeIncrement() !== calendarConfiguration.TimeIncrement ||
        getWorkDays() !== calendarConfiguration.WorkDays ||
        getShowWeekNumbers() !== calendarConfiguration.ShowWeekNumbers ||
        getFirstWeekOfYear() !== calendarConfiguration.FirstWeekOfYear ||
        getWorkingHoursStartTime() !== calendarConfiguration.WorkingHoursStartTime ||
        getWorkingHoursEndTime() !== calendarConfiguration.WorkingHoursEndTime ||
        getWorkingHoursTimeZoneId() !== WorkingHoursTimeZoneId
    );
}
